import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "101",
  "slug": "how-big-is-africa-really",
  "title": "How to Compare Africa’s Size Without a Misleading Map",
  "excerpt": "Area, travel distance, and landscape variety answer different questions about the continent.",
  "date": "2026-03-20",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Africa extends across the equator, from the Mediterranean to the southern Atlantic and Indian Ocean coasts. To compare its area with another region, start with an equal-area map or published area figures. A Mercator map exaggerates high-latitude regions beside it."
    },
    {
      "type": "heading",
      "text": "Area is different from fitting shapes together"
    },
    {
      "type": "paragraph",
      "text": "A collage that places several countries inside Africa can communicate scale, but the arrangement is an illustration. A sum of country areas does not prove their outlines fit without overlap. Check whether a comparison uses land area or total area, and whether it includes islands and inland water."
    },
    {
      "type": "heading",
      "text": "Compare distances as well"
    },
    {
      "type": "paragraph",
      "text": "Choose two named points, such as Cairo and Cape Town, and measure their great-circle separation with a geographic distance tool. That gives you a different sense of scale from the area of the continent. It still does not measure a road journey, which follows available routes."
    },
    {
      "type": "heading",
      "text": "Look within the outline"
    },
    {
      "type": "paragraph",
      "text": "For an image exercise, compare a stretch of the Nile Valley, the Congo Basin, and the southern African plateau at the same scale. Record the drainage, relief, and visible land cover in each. One national or continental outline contains landscapes that need quite different explanations."
    },
    {
      "type": "paragraph",
      "text": "Knowing the scale is useful, but it should be the beginning of looking more closely. It does not justify treating the continent as a single landscape or a single social setting."
    }
  ],
  "sources": [
    {
      "title": "USGS: how map projections are used",
      "url": "https://www.usgs.gov/faqs/how-are-different-map-projections-used"
    }
  ],
  "relatedSlugs": [
    "why-greenland-looks-bigger-than-africa-on-maps"
  ]
};
